import { geographyText } from "./geography";

/** Public bodies as the records name them in English (issuing authorities, trade registries), in the reader's language. */
const AUTHORITIES: Record<string, string> = {
  "Ministry of Economy": "وزارة الاقتصاد",
  "Ministry of Economy and Tourism": "وزارة الاقتصاد والسياحة",
  "UAE Ministry of Economy and Tourism": "وزارة الاقتصاد والسياحة",
  "UAE Ministry of Economy & Tourism": "وزارة الاقتصاد والسياحة",
  "Ministry of Health and Prevention": "وزارة الصحة ووقاية المجتمع",
  "Department of Health – Abu Dhabi": "دائرة الصحة – أبوظبي",
  "Dubai Health Authority": "هيئة الصحة بدبي",
  "SEHA – Abu Dhabi Health Services": "شركة أبوظبي للخدمات الصحية (صحة)",
  "Ministry of Energy and Infrastructure": "وزارة الطاقة والبنية التحتية",
  "Ministry of Finance": "وزارة المالية",
  "Ministry of Human Resources and Emiratisation": "وزارة الموارد البشرية والتوطين",
  "Sharjah Roads and Transport Authority": "هيئة الطرق والمواصلات في الشارقة",
  "Roads and Transport Authority": "هيئة الطرق والمواصلات",
  "Roads and Transport Department – Sharjah": "هيئة الطرق والمواصلات في الشارقة",
  "Roads and Transport Department": "دائرة الطرق والمواصلات",
  Uploaded: "مستند مرفوع",
  "Northern Emirates Municipal Affairs Council": "مجلس الشؤون البلدية في الإمارات الشمالية",
  "Telecommunications and Digital Government Regulatory Authority": "هيئة تنظيم الاتصالات والحكومة الرقمية",
  "Central Bank of the UAE": "مصرف الإمارات العربية المتحدة المركزي",
  "Securities and Commodities Authority": "هيئة الأوراق المالية والسلع",
  "Abu Dhabi Department of Economic Development": "دائرة التنمية الاقتصادية في أبوظبي",
  "Department of Economic Development - Dubai": "دائرة الاقتصاد والسياحة في دبي",
  "Department of Economy and Tourism - Dubai": "دائرة الاقتصاد والسياحة في دبي",
  "Dubai Multi Commodities Center (DMCC) Free Zone": "مركز دبي للسلع المتعددة",
  "Dubai Multi Commodities Centre (DMCC)": "مركز دبي للسلع المتعددة",
  "Dubai Financial Service Authority (DFSA)": "سلطة دبي للخدمات المالية",
  "Dubai Financial Services Authority (DFSA)": "سلطة دبي للخدمات المالية",
  "Dubai Silicon Oasis Authority (DSOA)": "سلطة واحة دبي للسيليكون",
  "Dubai World": "دبي العالمية",
  "Dubai Investment Fund": "صندوق دبي للاستثمار",
  "Sharjah Media City Free Zone (Shams)": "المنطقة الحرة لمدينة الشارقة للإعلام (شمس)",
  "RAK International Corporate Centre (RAK ICC)": "مركز رأس الخيمة الدولي للشركات",
  "Fujairah Free Zone Company Listing": "سجل شركات المنطقة الحرة بالفجيرة",
  "Jebel Ali Free Zone Authority (JAFZA)": "سلطة المنطقة الحرة لجبل علي",
  "Abu Dhabi Global Market (ADGM)": "سوق أبوظبي العالمي",
  "Dubai International Financial Centre (DIFC)": "مركز دبي المالي العالمي",
  "Dubai International Financial Centre": "مركز دبي المالي العالمي",
  "Abu Dhabi Global Market Registration Authority": "سلطة التسجيل في سوق أبوظبي العالمي",
  "Temporary Code": "رمز مؤقت",
  "Ras Al Khaimah Economic Zone": "المنطقة الاقتصادية في رأس الخيمة",
  "Ajman Free Zone Authority": "هيئة المنطقة الحرة في عجمان",
  "Hamriyah Free Zone Authority": "هيئة المنطقة الحرة بالحمرية",
  "Meydan Free Zone": "المنطقة الحرة في ميدان",
  "Dubai Airport Free Zone": "المنطقة الحرة لمطار دبي",
  "Sharjah Airport International Free Zone": "المنطقة الحرة لمطار الشارقة الدولي",
  "Umm Al Quwain Chamber of Commerce and Industry": "غرفة تجارة وصناعة أم القيوين",
  "Economic Development Department": "دائرة التنمية الاقتصادية",
  "Department of Economic Development": "دائرة التنمية الاقتصادية",
  "Creative City Free Zone Authority": "هيئة المنطقة الحرة للمدينة الإبداعية",
  "Umm Al Quwain Free Trade Zone Authority": "هيئة المنطقة الحرة في أم القيوين",
  "Dubai Development Authority": "سلطة دبي للتطوير",
  "Sharjah Chamber of Commerce and Industry: Business Directory": "غرفة تجارة وصناعة الشارقة: دليل الأعمال",
  "Department of Economic Development - Ajman": "دائرة التنمية الاقتصادية في عجمان",
  "Chamber of Commerce and Industry: Industrial and Business Directory": "غرفة التجارة والصناعة: الدليل الصناعي والتجاري",
  "Federal Tax Authority": "الهيئة الاتحادية للضرائب",
  "Sharjah Research Technology and Innovation Park Authority (SRTIP)": "هيئة مجمع الشارقة للبحوث والتكنولوجيا والابتكار",
  "Abu Dhabi DED": "دائرة التنمية الاقتصادية في أبوظبي",
  "Dubai DET": "دائرة الاقتصاد والسياحة في دبي",
  "Dubai Economy & Tourism": "دائرة الاقتصاد والسياحة في دبي",
  "Central Bank of the UAE (simulated)": "مصرف الإمارات العربية المتحدة المركزي (محاكاة)",
  "Fujairah Chamber of Commerce and Industry: Business Directory": "غرفة تجارة وصناعة الفجيرة: دليل الأعمال",
  "Fujairah Municipality": "بلدية الفجيرة",
  "The Netherlands Chamber of Commerce": "غرفة التجارة الهولندية",
  "Fujairah Department of Industry and Economy": "دائرة الصناعة والاقتصاد في الفجيرة",
  "RAK DED": "دائرة التنمية الاقتصادية في رأس الخيمة",
  "Ras Al Khaimah DED": "دائرة التنمية الاقتصادية في رأس الخيمة",
  "Ajman DED": "دائرة التنمية الاقتصادية في عجمان",
  "Sharjah DED": "دائرة التنمية الاقتصادية في الشارقة",
  "Sharjah Economic Development Department": "دائرة التنمية الاقتصادية في الشارقة",
  "Fujairah DED": "دائرة التنمية الاقتصادية في الفجيرة",
  "Dubai South Free Zone": "المنطقة الحرة في دبي الجنوب",
  "JAFZA": "سلطة المنطقة الحرة لجبل علي",
  "Infocamere": "إنفوكاميري (السجل التجاري الإيطالي)",
  "Companies House": "دار الشركات (المملكة المتحدة)",
  "Cayman Islands Monetary Authority": "سلطة النقد في جزر كايمان",
  "No Registration Authority available": "جهة التسجيل غير متاحة",
  "Council of Australian Governments": "مجلس الحكومات الأسترالية",
  "European Commission": "المفوضية الأوروبية",
  "Bundeskartellamt": "مكتب مكافحة الاحتكار الاتحادي الألماني",
  "Federal Competitiveness and Statistics Centre": "المركز الاتحادي للتنافسية والإحصاء",
  "GCC Ministerial Council": "المجلس الوزاري لمجلس التعاون لدول الخليج العربية",
  "GCC Secretariat General": "الأمانة العامة لمجلس التعاون لدول الخليج العربية",
  "GCC Supreme Council": "المجلس الأعلى لمجلس التعاون لدول الخليج العربية",
  "International Competition Network": "الشبكة الدولية للمنافسة",
  "Legal Affairs site – opinions register": "سجل الآراء القانونية – إدارة الشؤون القانونية",
  "Minister of Economy & Tourism": "وزير الاقتصاد والسياحة",
  "Ministry of Economy & Tourism": "وزارة الاقتصاد والسياحة",
  "Ministry of Economy & Tourism – Competition Department": "وزارة الاقتصاد والسياحة – إدارة المنافسة",
  "Ministry of Economy & Tourism – Economic Studies & Analysis Department": "وزارة الاقتصاد والسياحة – إدارة الدراسات والتحليل الاقتصادي",
  "Ministry of Economy & Tourism – Legal Affairs Department": "وزارة الاقتصاد والسياحة – إدارة الشؤون القانونية",
  "Ministry of Economy & Tourism – Minister's decision (sanitised)": "وزارة الاقتصاد والسياحة – قرار الوزير (بعد حجب السري)",
  "MOET Competition Department": "إدارة المنافسة في وزارة الاقتصاد والسياحة",
  OECD: "منظمة التعاون الاقتصادي والتنمية",
  "President of the UAE": "رئيس الدولة",
  "UAE Cabinet": "مجلس الوزراء",
  "UAE Government": "حكومة دولة الإمارات",
  "UAE Supreme Council": "المجلس الأعلى للاتحاد",
  "UK Competition & Markets Authority": "هيئة المنافسة والأسواق في المملكة المتحدة",
  "Ministry of Industry and Advanced Technology": "وزارة الصناعة والتكنولوجيا المتقدمة",
  "Federal Transport Authority": "الهيئة الاتحادية للمواصلات البرية والبحرية",
  MOHAP: "وزارة الصحة ووقاية المجتمع",
  "MOHAP / EDE": "وزارة الصحة ووقاية المجتمع / مؤسسة الإمارات للدواء",
  "MOHAP (medical device registration) · Emirates Drug Establishment": "وزارة الصحة ووقاية المجتمع (تسجيل الأجهزة الطبية) · مؤسسة الإمارات للدواء",
  "KHDA / ADEK / MOE": "هيئة المعرفة والتنمية البشرية / دائرة التعليم والمعرفة / وزارة التربية والتعليم",
  TDRA: "هيئة تنظيم الاتصالات والحكومة الرقمية",
  "Capital Market Authority": "هيئة سوق رأس المال",
  "Insurance Authority": "هيئة التأمين",
  "General Civil Aviation Authority": "الهيئة العامة للطيران المدني",
};
const KEYS = new Map(Object.entries(AUTHORITIES).map(([k, v]) => [k.toLowerCase(), v]));

export function authorityText(value: string | null | undefined, locale: string): string {
  if (!value) return "";
  if (!locale.startsWith("ar")) return value;
  const known = KEYS.get(value.trim().toLowerCase());
  if (known) return known;
  const draft = value.match(/^Draft No\.\s*(.+)$/i);
  if (draft) return `مسودة رقم ${draft[1]}`;
  return geographyText(value, locale);
}
